import Vue from "vue";
import { RouteConfig } from "vue-router";

import { PermissionName } from "../../common/mixins/permission";
import MigrateExportCustomerPage from "@/features/migrate/pages/MigrateExportCustomerPage.vue";
import MigrateExportCategoryPage from "@/features/migrate/pages/MigrateExportCategoryPage.vue";
import MigrateExportProductPage from "@/features/migrate/pages/MigrateExportProductPage.vue";
import MigrateExportInventoryPage from "@/features/migrate/pages/MigrateExportInventoryPage.vue";

export const MigrateRouter: (prefix?: string) => RouteConfig[] = (
  prefix = "migrate"
) => [
  {
    name: "MigrateExportCustomerPage",
    path: `${prefix}/exportcustomer`,
    component: MigrateExportCustomerPage,
    meta: { title: "Export customer" },
    beforeEnter: (to, from, next) => {
      if (
        Vue.prototype.$dep.authUseCase.hasPermission(
          PermissionName.MIGRATE_ACTION
        )
      ) {
        document.title = to.meta.title;
        next();
        return;
      }
      next({ path: "/" });
    }
  },
  {
    name: "MigrateExportCategoryPage",
    path: `${prefix}/exportcategory`,
    component: MigrateExportCategoryPage,
    meta: { title: "Export category" },
    beforeEnter: (to, from, next) => {
      if (
        Vue.prototype.$dep.authUseCase.hasPermission(
          PermissionName.MIGRATE_ACTION
        )
      ) {
        document.title = to.meta.title;
        next();
        return;
      }
      next({ path: "/" });
    }
  },
  {
    name: "MigrateExportProductPage",
    path: `${prefix}/exportproduct`,
    component: MigrateExportProductPage,
    meta: { title: "Export product" },
    beforeEnter: (to, from, next) => {
      if (
        Vue.prototype.$dep.authUseCase.hasPermission(
          PermissionName.MIGRATE_ACTION
        )
      ) {
        document.title = to.meta.title;
        next();
        return;
      }
      next({ path: "/" });
    }
  },
  {
    name: "MigrateExportInventoryPage",
    path: `${prefix}/exportinventory`,
    component: MigrateExportInventoryPage,
    meta: { title: "Export inventory" },
    beforeEnter: (to, from, next) => {
      if (
        Vue.prototype.$dep.authUseCase.hasPermission(
          PermissionName.MIGRATE_ACTION
        )
      ) {
        document.title = to.meta.title;
        next();
        return;
      }
      next({ path: "/" });
    }
  }
];
